"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchLogProcessor = exports.getIsRemoteLoggingEnabled = void 0;
const sendLogs_1 = require("../logs/sendLogs");
const dotenv_1 = require("dotenv");
const getIsRemoteLoggingEnabled = () => {
    var _a;
    (0, dotenv_1.config)();
    return (((_a = process.env.IS_REMOTE_LOGGING_ENABLED) !== null && _a !== void 0 ? _a : process.env.NEXT_PUBLIC_IS_REMOTE_LOGGING_ENABLED) === 'true');
};
exports.getIsRemoteLoggingEnabled = getIsRemoteLoggingEnabled;
class BatchLogProcessor {
    constructor(options) {
        this.logEntries = [];
        // Default flush every 10 seconds
        this.flushInterval = options.flushIntervalMs;
        this.flushSize = options.flushSize;
        const interval = setInterval(() => this.flushLogs(), this.flushInterval);
        if (interval.unref) {
            interval.unref();
        }
        this.isEnabled = (0, exports.getIsRemoteLoggingEnabled)();
        if (typeof window !== 'undefined') {
            window.onbeforeunload = () => {
                this.flushLogs();
            };
        }
    }
    write(logEntry) {
        if (!this.isEnabled)
            return;
        this.logEntries.push(logEntry);
        if (this.logEntries.length >= this.flushSize) {
            this.flushLogs();
        }
    }
    flushLogs() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isEnabled)
                return;
            if (this.logEntries.length === 0) {
                return; // No logs to send
            }
            const payload = this.logEntries.map((entry) => entry);
            this.logEntries = []; // Clear the buffer
            try {
                yield (0, sendLogs_1.sendLogsBatch)(payload);
            }
            catch (error) {
                console.error('Failed to flush logs to Eupheus. Printing logs that should have been sent below:', error);
                payload.map((logEntry) => console.log(logEntry));
            }
        });
    }
}
exports.BatchLogProcessor = BatchLogProcessor;
//# sourceMappingURL=BatchLogProcessor.js.map